export enum ListTypes {
  /* Globals */
  Menu = "Proyecta-Menú",
  TopMenu = "MenuSuperior",
  NavBar = "NavBar",
  Langs = "Lenguaje",
  Params = "Parametros",
  Labels = "Proyecta-Etiquetas",
  Routes = "Proyecta-Rutas",
  consecutive = "Proyecta-Consecutivo",
  Gaps = "Gaps",
  /* Masters */
  Region = "Region",
  Country = "Pais",
  BudgetType = "Proyecta-Tipo de presupuesto",
  MeasureUnits = "Proyecta-Medidas",
  Year = "Proyecta-Año",
  GrantCode = "EstructuraContable",
  StrategicLine = "Proyecta-Indicador línea estratégica",
  InterventionLine = "LineaIntervencion",
  NatureExpenditure = "Proyecta-Naturaleza de gasto",
  SAPFinancingEntity = "FinanciadorSap",
  CECO = "Proyecta-Ceco",
  Campaign = "Proyecta-Campañas",
  Department = "CodigoDepartamento",
  Purpose = "Proyecta-Finalidad",
  Project = "CodigoProyecto",
  /* Budget */
  BudgetBasicDataColumn = "Proyecta-Definición columnas datos básicos",
  BudgetDetailDataColumn = "Proyecta-Definición columnas detalle presupuesto",
  BaseBudget = "Proyecta-Presupuesto",
  DetailDataBudget = "Proyecta-Detalle Presupuesto",
  FoundType = "Proyecta-Tipo de fondo",
  BudgetSummary = "Proyecta-Resumen presupuesto",
  projectCode = "CodigoProyecto",
  BudgetByCountry = "Proyecta-Presupuesto por pais",
  BudgetByOn = "Proyecta-Presupuesto por On",
  BudgetResumeDataColumn = "Proyecta-Definición columnas resumen presupuesto",
  BudgetIndexDataColumn = "Proyecta-Definición Columnas Indice",
  BudgetTableBudgetByProject = "Proyecta-Definición Columnas Tabla Presupuesto Proyecto",
  BudgetCsvDataColumn = "Proyecta-Definición Columnas Presupuesto CSV",
  Sectores = "Sectores",
  ProaColumDefinitionFR = "Proyecta-Definicion columnas proa subproyecto fr",
  /* Proa */
  ProaColumDefinitionBasicData = "Proyecta-Definición columnas form proa",
  ProaDataTableBaseline = "Proyecta-Definicion columnas linea base",
  ProaDataTableBenefic = "Proyecta-Proa Beneficiarios",
  BaseProa = "Proyecta-Datos básicos R_G_PROY",
  ProaRGSecciones = "Proyecta-RGSecciones",
  ProaSummaryColumnDefinition = "Proyecta-Definicion Columnas Resumen Proa",
  ProaDetailsColumnDefinition = "Proyecta-Definicion Columnas Detalle Proa",
  ProaSummaryData = "Proyecta-Resumen Proa",
  TypeRRHH = "Proyecta-RRHH tipo",
  Collective = "Colectivo",
  BaseRRHH = "Proyecta-DatosRRHH",
  BaseFFRR = "Proyecta-Datos básicos FFRR",
  BaseSPC = "Proyecta-Datos básicos SPC",
  BaseFFRRBeneficiarios = "Proyecta-FFRR-SPC-BeneficiariosAnios",
  ProyectaConfig = "Proyecta-Configuracion",
  IntermediateResult = "Proyecta-Resultado intermedio",
  SLEP = "SLEP",
  ADT = "ADTCCAA",
  IntermediateIndicatorResults = "Proyecta-Indicador resultado intermedio",
  Products = "Proyecta-Productos",
  ProductsIndicator = "Proyecta-Indicador producto",
  ProaSubproyectoFRStep1 = "Proyecta-Proa Subproyecto FR Step1",
  ProaSubproyectoFRStep1Anios = "Proyecta-Proa Subproyecto FR Step1 Anios",
  ProaSubproyectoFRStep2 = "Proyecta-Proa Subproyecto FR Step2",
  ProaSubproyectoFRStep2Anios = "Proyecta-Proa Subproyecto FR Step2 Anios",
  ProaSubproyectoFRStep3 = "Proyecta-Proa Subproyecto FR Step3",
  ProaSubproyectoFRStep3Anios = "Proyecta-Proa Subproyecto FR Step3 Anios",
  ProaSubproyectoFRStep4 = "Proyecta-Proa Subproyecto FR Step4",
  ProaSubproyectoFRStepSDC = "PProaContrapartida",
  ProaSubproyectoFRStepSDCAnios = "PProaContrapartidaAnios",
  ProaTipoContrapartida = "Proyecta-Tipo Contrapartida",
  ProaSubproyectoFRStep4LineaBase = "Proyecta-Proa Subproyecto FR Step4 Linea Base",
  ProaSubproyectoFRStep4LineaBaseAnios = "Proyecta-Proa Subproyecto FR Step4 Linea base Anios",
  ProaSubproyectoFRStep4Productos = "Proyecta-Proa Subproyecto FR Step4 Productos",
  ProaSubproyectoFRStep4ProductosAnios = "Proyecta-Proa Subproyecto FR Step4 Productos Anios",
  ProaSubproyectoFRDefinicionColumnas = "Proyecta-Definicion columnas proa subproyecto fr",
  PresupuestoSedeOn = "Proyecta-Presupuesto Tipo Sede On",
  ProaDocuments = "Proyecta-DocumentosProa",
  ProaDocumentsPost = "ProyectaDocumentosProa",
  ProaLocalization = "Proyecta-Localizacion",
  ProaAdt = "Proyecta-ADT",
  ProaSubproyectoFEDefinicionColumnas = "Proyecta-Definicion Columnas Proa Subproyecto FE",
  ProaSubproyectoFEStep4 = "Proyecta-Proa Subproyecto FE Step4",
  ProaSubproyectoFEStep4MRI = "PProaStep4MRI",
  ProaSubproyectoFEStep4MRIAnios = "PProaStep4MRIAnios",
  ProaSubproyectoFEStep4Objetivo = "Proyecta-Proa Subproyecto FE Step4 Indicador Objetivo",
  ProaSubproyectoFEStep4ObjetivoAnios = "Proyecta-Proa Subproyecto FE Step4 Indicador Objetivo Anio",
  ProaSubproyectoFEStep4Resultados = "Proyecta-Proa Subproyecto FE Step4 Resultado Esperado",
  ProaSubproyectoFEStep4ResultadosDetalles = "Proyecta-Proa Subproyecto FE Step4 Resultado Esperado Detalle",
  ProaSubproyectoFEStep4ResultadosDetallesAnios = "Proyecta-Proa Subproyecto FE Step4 Resultado Esperado Detalle Anio",
  ProaSubproyectoFEStep4Actividad = "Proyecta-Proa Subproyecto FE Step4 Actividad",
  ProaSubproyectoFEStep4ActividadAnios = "Proyecta-Proa Subproyecto FE Step4 Actividad Anio",
  ErrorLog = "Proyecta-ErrorLog",
  MetaExcecutionPeriod = "PlazoEjecucion",
  MetaTechnicalAspects = "AspectosTecnicos",
  MetaBeneficiaryCollectives = "ColectivoBeneficiario",
  UserHelpLibrary = "Docs-Ayuda",
  OctaviaHelpLibrary = "Octavia-Docs-Ayuda",
  CofiHelpLibrary = "Cofi-Docs-Ayuda",
  ProaDocumentosDefinicionColumnas = "Proyecta-Definición Columnas Documentos",
  PProaBeneficiariosDuplicados = "PProaBeneficiariosDuplicados",
  PProaBeneficiariosDuplicadosPais = "PProaBeneficiariosDuplicadosPais",
  ProaCostRecovery = "Proyecta-Recuperación de costes",
  /*Administration*/
  GlobalAdministration = "Adminstración Global",
  AdminSections = "Secciones Adiminstracion",
  Applications = "Indice Aplicaciones",
  /*Followup*/
  IndexFollowup = "Seguimiento - Indice",
  AdminColumnDefinition = "Definicion Columnas - Seguimiento Administracion",
  FollowupColumnDefinition = "Definicion Columnas - Seguimiento Indice",
  IndicatorsColumnDefinition = "Definicion Columnas - Seguimiento Indicadores",
  FinancialColumnDefinition = "Definicion Columnas - Seguimiento Financiera",
  BeneficiariesColumnDefinition = "Definicion Columnas - Seguimiento Beneficiarios",
  SeguimientoEstadoSubproyectoDimensiones = "Seguimiento - Estado Subproyecto Dimensiones",
  SeguimientoEstadoSubproyectoMeses = "Seguimiento - Estado Subproyecto Meses",
  SeguimientoEstadoSubproyectoPeriodos = "Seguimiento - Estado Subproyecto Periodos",
  SeguimientoInPeriodos = "Seguimiento - Periodos",
  FollowupLabels = "Seguimiento - Etiquetas",
  FollowupState = "Seguimiento - Estado",
  FollowupDimensions = "Seguimiento - Dimensiones",
  SeguimientoIndObjEspecificos = "Seguimiento - Indicadores - Objetivos Especificos",
  SeguimientoResultadosEsperados = "Seguimiento - Indicadores - Resultados Esperados",
  SeguimientoActividades = "Seguimiento - Indicadores - Actividades",
  SeguimientoLineaPrincipal = "Seguimiento - Indicadores - Linea Principal",
  SeguimientoLineaSecundaria = "Seguimiento - Indicadores - Linea Secundaria",
  SeguimientoResultadosInstitucionales = "Seguimiento - Indicadores - Resultados",
  SeguimientoProductosInstitucionales = "Seguimiento - Indicadores - Productos",
  SuccessCriteria = "Criterio de exito",
  Frecuency = "Frecuencia de medicion",
  SeguimientoInformeNarrativo = "Seguimiento - Informe Narrativo",

  FinancieraResultadosEsperadosTotales = "Seguimiento - Financiera - Resultados Esperados Totales",
  FinancieraResultadosEsperados = "Seguimiento - Financiera - Resultados Esperados",
  FinancieraPresupuestoImplementadores = "Seguimiento - Financiera - Presupuesto por Implementadores",
  FinancieraPresupuestoLocalizaciones = "Seguimiento - Financiera - Presupuesto por Localizaciones",
  FinancieraPresupuestoADT = "Seguimiento - Financiera - Presupuesto por ADT",
  FinancieraPresupuestoSDC = "Seguimiento - Financiera - Presupuesto por origen de fondos",
  FollowupAgeRange = "Seguimiento - Rango Edades",
  FollowupRuralities = "Seguimiento - Ruralidades",
  BeneficiariesByAge = "Seguimiento - Beneficiarios x Edad",
  BeneficiariesByLocation = "Seguimiento - Beneficiarios x Localizacion",
  BeneficiariesByRurality = "Seguimiento - Beneficiarios x Ruralidad",
  BeneficiariesByResult = "Seguimiento - Beneficiarios - Resultados Esperados",
  BeneficiariesByOverlap = "Seguimiento - Beneficiarios - Superposicion x Proyecto",
  BeneficiariesByGen = "Seguimiento - Beneficiarios - Desagregacion x Genero",
  BeneficiariesBySubPr = "Seguimiento - Beneficiarios - Planeación x SubProyecto",
  BeneficiariesBySubPrLogs = "Seguimiento - Beneficiarios - Planeación x SubProyecto - Logs",
  SeguimientoLineaPrincipalLogs = "Seguimiento - Indicadores - Linea Principal - Logs",
  SeguimientoLineaSecundariaLogs = "Seguimiento - Indicadores - Linea Secundaria - Logs",
  SeguimientoResultadosInstitucionalesLogs = "Seguimiento - Indicadores - Resultados  - Logs",
  SeguimientoProductosInstitucionalesLogs = "Seguimiento - Indicadores - Productos - Logs",
  SeguimientoIndObjEspecificosLogs = "Seguimiento - Indicadores - Objetivos Especificos - Logs",
  SeguimientoResultadosEsperadosLogs = "Seguimiento - Indicadores - Resultados Esperados - Logs",
  SeguimientoActividadesLogs = "Seguimiento - Indicadores - Actividades - Logs",

  SeguimientoLineaPrincipalVersion = "Seguimiento - Version - Indicadores - Linea Principal",
  SeguimientoLineaSecundariaVersion = "Seguimiento - Version - Indicadores - Linea Secundaria",
  SeguimientoResultadosInstitucionalesVersion = "Seguimiento - Version - Indicadores - Resultados",
  SeguimientoProductosInstitucionalesVersion = "Seguimiento - Version - Indicadores - Productos",
  SeguimientoIndObjEspecificosVersion = "Seguimiento - Version - Indicadores - Objetivos Especificos",
  SeguimientoResultadosEsperadosVersion = "Seguimiento - Version - Indicadores - Resultados Esperados",
  SeguimientoActividadesVersion = "Seguimiento - Version - Indicadores - Actividades",
  FinancieraPresupuestoImplementadoresVersion = "Seguimiento - Version - Financiera- Presupuesto por Implementadores",
  FinancieraPresupuestoADTVersion = "Seguimiento - Version - Financiera - Presupuesto por ADT",
  FinancieraPresupuestoLocalizacionesVersion = "Seguimiento - Version - Financiera - Presupuesto por Localizaciones",
  FinancieraPresupuestoSDCVersion = "Seguimiento - Version - Financiera - Presupuesto por origen de fondos",
  FinancieraResultadosEsperadosVersion = "Seguimiento - Version - Financiera - Resultados Esperados Actividades",

  BeneficiariesBySubPrVersion = "Seguimiento - Version - Beneficiarios - Planeacion por subproyecto",
  BeneficiariesByOverlapVersion = "Seguimiento - Version - Beneficiarios - Superposicion",
  BeneficiariesByResultVersion = "Seguimiento - Version - Beneficiarios -Actividades Resultado Esperado",
  BeneficiariesByGenVersion = "Seguimiento - Version - Beneficiarios - Desagregacion por genero",
  BeneficiariesByAgeVersion = "Seguimiento - Version - Beneficiarios - Por Edad",
  BeneficiariesByLocationVersion = "Seguimiento - Version - Beneficiarios - Por Localizacion",
  BeneficiariesByRuralityVersion = "Seguimiento - Version - Beneficiarios - Por Ruralidad",

  FollowupByProjectOverlap = "Seguimiento - Sup Beneficiarios x Proyecto - Super P",
  FollowupBenByProject = "Seguimiento - Sup Beneficiarios x Proyecto - Sin Duplicidad",
  FollowupByCountryOverlap = "Seguimiento - Sup Beneficiarios x Pais - Super P",
  FollowupBenByCountry = "Seguimiento - Sup Beneficiarios x Pais - Sin Duplicidad",
  
}

export const LocalStorageTemporaryTables : any = {
/*   MenuSuperior: {
      title: "MenuSuperior",
      columns: []
  },
  MenuLateral: {
      title: "MenuLateral",
      columns: []
  }, */
  Notificaciones: {
      title: "Notificaciones",
      columns: []
  },
  Lenguaje: {
      title: "Lenguaje",
      columns: []
  },
  Parametros: {
      title: "Parametros",
      columns: []
  },
  TipoDocumento: {
      title: "TipoDocumento",
      columns: []
  },
  FinanciadorSap: {
      title: "FinanciadorSap",
      columns: []
  },
  HitosControlCalidad: {
      title: "HitosControlCalidad",
      columns: []
  },
  EstadoOportunidad: {
      title: "EstadoOportunidad",
      columns: []
  },
  Pais: {
      title: "Pais",
      columns: []
  },
  EtiquetasGlobales: {
      title: "EtiquetasGlobales",
      columns: []
  },
  TipoFinanciador: {
      title: "TipoFinanciador",
      columns: []
  },
  Region: {
      title: "Region",
      columns: []
  },
  Gaps: {
      title: "Gaps",
      columns: []
  },
  PEPAprobacion: {
      title: "PEPAprobacion",
      columns: []
  },
  PropuestaConsorcio: {
      title: "PropuestaConsorcio",
      columns: []
  },
  CodigoOrigen: {
      title: "CodigoOrigen",
      columns: []
  },
  DefinicionColumnas: {
      title: "DefinicionColumnas",
      columns: []
  }
};

export enum LocalStorageKeys {
  currentLang = "_sys_current_lang",
  currentUser = "_sys_current_user",
  seenAppTourInd = "_seen_app_tour_ind",
  seenAppTourBen = "_seen_app_tour_ben",
  seenAppTourFin = "_seen_app_tour_fin",
  seenAppTourIN = "_seen_app_tour_in",
}
export enum SPUserProperties {
  Email = "Email",
}
export enum FieldTypes {
  Textarea = "textarea",
  Date = "date",
  Number = "number",
  Text = "text",
  Select = "select",
  User = "user",
  Checkbox = "checkbox",
  currency = "money",
  Percentage = "percentage",
  Radio = "radio",
  Boolean = "boolean",
  Button = "Button"
}
export enum PickerTypes {
  Calendar = "calendar",
}
export enum LangLabels {
  ES = "ES",
  PT = "PT",
  FR = "FR",
  EN = "EN",
}
export enum Columns {
  Title = "Title",
  Id = "Id",
  PPresTipoFondo = "PPresTipoFondo",
}
export enum FoundType {
  FFRR = "FFRR",
  FFCC = "FFCC",
}
export enum ConsecutiveKeys {
  PresCodigoProyecto = "PresCodigoProyecto",
}
export enum BudgetBasicFields {
  Type = "Tipo Presupuesto",
  Exist = "Existe",
  Year = "Año",
  Country = "País",
  PrTitle = "Título de proyecto",
  PrNumber = "Número de proyecto",
  PrCode = "Código proyecto",
  IntLine = "Línea de intervención",
}
export enum ProaBasicFields {
  //Proa Form FFRR
  Id = "Id",
  FechaInicio = "OCTAVIAFechaInicio",
  FechaFin = "OCTAVIAFechaFinalizacion",
  IndicadorLE = "PPresIndicadorLineaEstrategicaId",
  IndicadorLE1 = "PPresIndicadorLineaEstrategica1Id",
  LineaBase = "PFFRRLineaBase",
  PProaAnioLineaBase = "PProaAnioLineaBase",
  LineaBaseMeta = "LineaBaseMeta",
  Meta = "PPresAnioMeta",
  MetaValor = "PProaAnioValue",
  TotalMeta = "PPresTotalAnio",
  BeneficiarioAnio = "PPresuAnio",
  TotalHombres = "PFFRRTotalHombres",
  TotalMujeres = "PFRRTotalMujeres",
  TotalGeneral = "TotalGeneral",
  Indice = "Indice",
  Implementador = "OCTAVIASLEPId",
  TotalImplementadores = "TotalImplementadores",
  PProaTipoContrapartida = "PProaTipoContrapartida",
  TotalContrapartidas = "TotalContrapartidas",
  IdContrapartida = "IdContrapartida",
  Año = "Año",
  Location = "PProaLocationId",
  TotalLocation = "TotalZona",
  ADT = "PProaAdtId",
  TotalADT = "TotalAdt",
  TotalADTLOC = "PFFRRTotal",
  GenericDataId = "PProaFRStep1Id",
  GenericDataId2 = "PProaFRStep2Id",
  GenericDataId3 = "PProaFRStep3Id",
  GenericDataId4 = "PProaFRStep4Id",
  GenericDataIdSDC = "PProaContrapartidaId",
  GenericDataId4Bs = "PProaFRStep4LineaBaseId",
  GenericDataId4Pr = "PProaFRStep4ProductosId",
  IntermediateResult = "PFFRRCodigoResultadoIntermedioId",
  IndicatorIntermediateResult = "PFFRRIndicadorResultadoIntermediId",
  TotalIntermediateResult = "PPresTotalAnio",
  MetaFinal = "PProaMetaFinal",
  CodigoProducto = "PFFRRCodigoProductoId",
  IndicadorProducto = "PFFRRIndicadorProductoId",
  MetaTotalProyecto = "PProaMetaTotalProyecto",
  TotalProyecto = "PFFRRTotal",
  SubTotal = "PFFRRSubTotal",
  //** */
  CodSubvencionId = "PPresCodSubvencionId",
  Planificacion = "PlanificacionAprobada",
  PrCode = "Código de proyecto",
  Country = "País/Región",
  NombreProyecto = "Nombre proyecto",
  ObjetivoEstrategico = "ObjetivoEstrategico",
  Region = "Región",
  LineaEstrategica = "Línea estratégica",
  IndicadorLineaEstrategica = "Indicador línea estratégica",
  Methodology = "PRGMetodologia",
  BeneficiaryCollective = "PFRRBeneficiariosId",
  ProblemsAndJustification = "PRGProblematica",
  ProjectSummary = "PRGResumenProyecto",
  AEARol = "PRGRolAeA",
  ImplementersRol = "PRGRolImplementadores",
  OtrosImplementadores = "PRGOtrosImplementadores",
  OtrosRolesImplementadores = "PRGOtrosRolesImplementadores",
  AEAParticipatesInEjecution = "PRGParticipacion",
  BeneficiaryDescription = "PRGDescripcionBeneficiarios",
  CompletarLocaciones = "PRGLocalizacion",
  Etiquetas = "OCTAVIAEtiquetasId",
  TotalPersonasNecesarias = "PRGTotalPersonasnecesarias",
  TipoGerenteProyecto = "PRGTipoGerenteProyectoId",
  DedicacionGerente = "PRGDedicacionGerente",
  IdentificacionGerente = "PRGIdentificacionGerente0",
  TipoAdministrador = "PRGTipoAdministradorId",
  DedicacionAdministrador = "PRGDedicacionAdministrador",
  IdentificacionAdministrador = "PRGIdentificacionAdministrador0",
  ObjetivoEspecifico = "PProaObjetivo",
  TotalOE = "PFFRRTotal",
  PProaFEStep4InidicadorId = "PProaFEStep4InidicadorId",
  PProaStep4AdaptacionMRIId = "PProaStep4AdaptacionMRIId",
  PProaMetaFinanciera = "PProaMetaFinanciera",
  PFFRRIndicadorProductoId = "PFFRRIndicadorProductoId",
  PFFRRIndicadorResultadoIntermedioId = "PFFRRIndicadorResultadoIntermedioId",
  PProaMetaMRI = "PProaMetaMRI",
  PProaMRIPriority = "PProaMRIPriority",
  PProaDescripcion = "PProaDescripcion",
  PProaUnidadMedida = "PProaUnidadMedida",
  PProaMedidaId = "PProaMedidaId",
  PProaIndicadorObjetivo = "PProaIndicadorObjetivo",
  PProaResultadoEsperado = "PProaResultadoEsperado",
  PFFRRCodigoResultadoIntermedioId = "PFFRRCodigoResultadoIntermedioId",
  PProaIndicadorResultadoEsperado = "PProaIndicadorResultadoEsperado",
  PProaFEStep4ResultadoDetalleId = "PProaFEStep4ResultadoDetalleId",
  PProaFEStep4ResultadosEsperadosId = "PProaFEStep4ResultadosEsperadosId",

  PProaActividad = "PProaActividad",
  PFFRRTotal = "PFFRRTotal",
  PProaValorActividad = "PProaValorActividad",
  PProaFEStep4ActividadId = "PProaFEStep4ActividadId",
  PPresAnioMetaActivity = "PPresAnioMetaActivity",
  PMedidaId = "PMedidaId",
  PRGCodigoLineaIntervencionId = "PRGCodigoLineaIntervencionId",
  OCTAVIALineaIntervencionId = "OCTAVIALineaIntervencionId",
}
export enum FollowupBasicFields {

  // Admin - Indicators
  allow = "allow",
  state = "state",
  lastClosing = "lastClosing",
  nextClosing = "nextClosing",
  monthState = "monthState",
  year = "year",
  indicator = "indicator",
  baseLine = "baseLine",
  lbValue = "lbValue",
  lbUnity = "lbUnity",
  lbAnio = "lbAnio",
  criteria = "criteria",
  frecuency = "frecuency",
  plannedGoal = "plannedGoal",
  plannedGoalMod = "plannedGoalMod",
  endGoal = "endGoal",
  endGoalMod = "endGoalMod",
  achievedGoal = "achievedGoal",
  actualAchievedGoal = "actualAchievedGoal",
  currentProgressPercent = "currentProgressPercent",
  totalProgressPercent = "totalProgressPercent",
  selected = "selected",
  plannedAchievement = "plannedAchievement",
  plannedAchievementMod = "plannedAchievementMod",
  totalMonthPl = "totalMonthPl",
  currentAchievementAch = "currentAchievementAch",
  actualActAchievedGoal = "actualActAchievedGoal",
  totalAchievement = "totalAchievement",
  januaryPl = "januaryPl",

  // Success criteria

  reduce = "reduce",

  // Financial
  resume = "resume",
  budgetType = "budgetType",
  activity = "activity",
  result = "result",
  currentBudget = "currentBudget",
  currentBudgetMod = "currentBudgetMod",
  totalBudget = "totalBudget",
  totalBudgetMod = "totalBudgetMod",
  executedBudget = "executedBudget",
  accumBudgetExecuted = "accumBudgetExecuted",
  yearPercentage = "yearPercentage",
  projectPercentage = "projectPercentage",
  implementer = "implementer",
  location = "location",
  adt = "adt",
  sdc = "sdc",
  counterpart = "counterpart",

  // Beneficiaries
  description = "description",
  men = "men",
  women = "women",
  total = "total",
  planningMen = "planningMen",
  planningWomen = "planningWomen",
  planningTotal = "planningTotal",
  menMod = "menMod",
  womenMod = "womenMod",
  totalMod = "totalMod",
  beneficiariesByActivity = "beneficiariesByActivity",
  beneficiariesByResult = "beneficiariesByResult",
  achievedBeneficiaries = "achievedBeneficiaries",
  accumBeneficiaries = "accumBeneficiaries",
  activityPercentage = "activityPercentage",
  disaggregationDescription = "disaggregationDescription",
  descriptionValue = "descriptionValue",
  fieldTotal = "fieldTotal",
  fieldWomen = "fieldWomen",
  fieldMen = "fieldMen",
  fieldDescription = "fieldDescription",
  benefitedActivities = "benefitedActivities",

  // FollowupBy
  bySubproject = "bySubproject",
  byBeneficiaries = "byBeneficiaries",
}
export enum IndicatorType {
  type1 = 1,
  type2 = 2,
}

export enum SystemParameters {
  BudgetTypeOn = 2,
}
export enum ADTZona {
  ADT = 1,
  ZONA = 2,
}
export enum SedeOn {
  Sede = 1,
  On = 2,
}
export enum DataGridId {
  //proaFFRR
  BaseLineSt1 = "baseLineStep1",
  BeneficiariesSt1 = "beneficiariesStep1",
  ImplementersSt2 = "implementadoresStep2",
  ImplementersSummary = "implementadoresSummary",
  ImplementersFeSummary = "implementadoresFeSummary",
  LocationsSt3 = "locationStep3",
  LocationsSummary = "locationSummary",
  LocationsFeSummary = "locationFeSummary",
  AdtsSummary = "adtsummary",
  AdtsSt3 = "AdtsStep3",
  CounterpartsStSDC = "contrapartidasStepSDC_{0}",
  CounterpartsStSDCSummary = "contrapartidasStepSDCSummary_{0}",
  BaseLineSt4 = "baseLineStep4_{0}",
  ProductsSt4 = "productsStep4_{0}",
  ProductsSummary = "productsSummary",
  BaseLineFeSt1 = "baseLineStep1_{0}",
  BeneficiariesFeSt1 = "beneficiariesStep1_{0}",
  BeneficiariesMcFeSt1 = "beneficiariesMcStep1_{0}",
  ImplementersfESt2 = "implementadoresStep2_{0}",
  ImplementersfESt2Summary = "implementadoresStep2Summary_{0}",
  LocationsfESt3 = "locationStep3_{0}",
  LocationsfESt3Summary = "locationStep3Summary_{0}",
  AdtsfESt3Summary = "adtStep3Summary_{0}",
  ActfESt4Summary = "actStep4Summary_{0}",
  AdtsfESt3 = "AdtsStep3_{0}",
  MriIndicators = "feStep4MriIndicators_{0}",
  SpecificObjetives = "feStep4SpecificObjetivesId_T{0}_O{1}",
  ExpectedResults = "feStep4ExpectedResultsId_T{0}_O{1}_R{2}",
  Activities = "feStep4ActivitiesId_T{0}_O{1}_R{2}",
  ActivitiesSummary = "feStep4ActivitiesIdSummary_{0}",
}
export enum Prefix {
  IntermediateResult = "intrResult_{0}",
  IntermediateResultInd = "intrResultInd_{0}",
  Contributions = "A",
  Donations = "D",
}
export enum Params {
  impCodesExcludedCounterpart = "impCodes_excluded_counterpart",
  proyectaAdminModule = "proyecta_admin_module",
  nextClosingMassiveInitial = "next_closing_massive_initial",
  proyectaCentralTeam = "proyecta_central_team",
}
export enum CounterpartsType {
  Donation = "Donación",
  Grant = "Subvención"
}
export enum FollowupState {
  valid = "valid",
  closed = "closed",
  view = "view",
  read = "read",
  edit = "edit",
  followup = "followup",
  planning = "planning",
  substantialModifications = "substantialModifications",
  suspended = "suspended",
  january = "january",
  february = "february",
  march = "march",
  april = "april",
  may = "may",
  june = "june",
  july = "july",
  august = "august",
  september = "september",
  october = "october",
  november = "november",
  december = "december",
  monthOpen = "monthOpen",
  monthClosed = "monthClosed",
  presented = "presented",
  approved = "approved",
  process = "process",
  firstPeriod = "firstPeriod",
  secondPeriod = "secondPeriod",
}
export enum FollowupDimensions {
  indicators = "indicators",
  beneficiaries = "beneficiaries",
  financial = "financial",
  narrativeReport = "narrativeReport",
}
export enum NarrativeReportFields {
  sectionDeviations = "sectionDeviations",
  sectionRisks = "sectionRisks",
  sectionSubstantialModifications = "sectionSubstantialModifications",
  sectionNoSubstantialModifications = "sectionNoSubstantialModifications",
  sectionOther = "sectionOther",
  DesviacionesExplicacion = "DesviacionesExplicacion",
  DesviacionesMedidas = "DesviacionesMedidas",
  DesviacionesPlazos = "DesviacionesPlazos",
  RiesgosExplicaciones = "RiesgosExplicaciones",
  RiesgosMedidas = "RiesgosMedidas",
  RiesgosPlazos = "RiesgosPlazos",
  ModificacionesSustanciales = "ModificacionesSustanciales",
  ModificacionesNoSustanciales = "ModificacionesNoSustanciales",
  OtrosComentarios = "OtrosComentarios"
}